var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.95237 14.6162L8.95237 6.52285C8.94302 5.93103 8.70136 5.36661 8.27953 4.95139C7.85771 4.53618 7.28954 4.30346 6.69765 4.30346C6.10576 4.30346 5.53759 4.53618 5.11577 4.95139C4.69394 5.36661 4.45228 5.93103 4.44293 6.52285L4.43561 17.1311C4.42948 17.637 4.52381 18.139 4.71314 18.6081C4.90247 19.0772 5.18303 19.5041 5.53856 19.864C5.8941 20.2238 6.31752 20.5096 6.78431 20.7046C7.25109 20.8996 7.75193 21 8.25781 21C8.76369 21 9.26453 20.8996 9.73131 20.7046C10.1981 20.5096 10.6215 20.2238 10.9771 19.864C11.3326 19.5041 11.6132 19.0772 11.8025 18.6081C11.9918 18.139 12.0861 17.637 12.08 17.1311L12.08 6.45139C12.0903 5.73925 11.9589 5.03216 11.6936 4.37124C11.4282 3.71031 11.034 3.10874 10.5341 2.60149C10.0341 2.09425 9.4383 1.69145 8.78128 1.41652C8.12427 1.14158 7.41915 1 6.70693 1C5.99471 1 5.2896 1.14158 4.63259 1.41652C3.97557 1.69145 3.37977 2.09425 2.87981 2.60149C2.37985 3.10874 1.98571 3.71031 1.72032 4.37123C1.45492 5.03216 1.32356 5.73925 1.33386 6.45139L1.33386 16.4312",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.2628a802a4d3d639c0c69ded3aa2c7f3.svg";
export { ForwardRef as ReactComponent };